var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",staticClass:"form_control icon_date jsDatepickerInput",class:_vm.customClass,attrs:{"type":"text","placeholder":"DD/MM/YY"}})
}
var staticRenderFns = []

export { render, staticRenderFns }